// extracted by mini-css-extract-plugin
module.exports = {"brands":"brands_brands__ps4l8","banner":"brands_banner__1oInG","desc":"brands_desc__1Ua49"};